import { render, staticRenderFns } from "./update-additional-travellers-combined-products-list.vue?vue&type=template&id=7b523b4e&scoped=true"
import script from "./update-additional-travellers-combined-products-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./update-additional-travellers-combined-products-list.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./update-additional-travellers-combined-products-list.vue?vue&type=style&index=0&id=7b523b4e&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b523b4e",
  null
  
)

export default component.exports